import React from 'react';
import { Box, Typography } from '@mui/material';
import { ProvenanceTab, ProvenanceSectionId } from '../wizard/ProvenanceTab';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

const SECTIONS: ReadonlySet<ProvenanceSectionId> = new Set<ProvenanceSectionId>([
  'provenance-related-works',
]);

const NOTE =
  'Provide references to objects uploaded that are related to this object.';

/** Related works promoted from ProvenanceTab into its own step. */
export const RelatedWorksStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="related-works-step-note"
    >
      {NOTE}
    </Typography>
    <ProvenanceTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      visibleSections={SECTIONS}
      flatSections
    />
  </Box>
);
